import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbAuthModule, NbDummyAuthStrategy } from '@nebular/auth';
import { NbSecurityModule, NbRoleProvider } from '@nebular/security';
import { of as observableOf } from 'rxjs';
import { throwIfAlreadyLoaded } from './module-import-guard';
import { GenericTableModule } from './generic-table/generic-table.module';
import { HttpService } from './services/http.service';
import { LayoutService } from './services/layout.service';
import { AuthService } from './services/auth.service';
import { ToggleButtonCellComponent } from "./toggle-button/toggle-button.component";
import { NbButtonModule, NbCardModule, NbCheckboxModule, NbIconModule, NbInputModule, NbProgressBarModule, NbSelectModule, NbToggleModule, NbTooltipModule } from "@nebular/theme";
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { AddChildCellComponent } from './generic-button/add-child-cell.component';
import { ExportService } from './services/export.service';
import { DownloadButtonComponent } from './download-button/download-button.component';
import { SelectButtonComponent } from './select-button/select-button.component';
import { IconButtonComponent } from './icon-button/icon-button.component';
import { TooltipCellComponent } from './tooltip-cell/tooltip-cell.component';
import { TextareaComponent } from './textarea-component/textarea.component';
import { CheckboxCellComponent } from './checkbox-cell/checkbox-cell.component';
import { BooleanCellComponent } from './boolean-cell/boolean-cell.component';
import { JsonViewerComponent } from './json-viewer-component/json-viewer.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { ProgressBarCellComponent } from './progress-bar-cell/progress-bar-cell.component';
import { MultipleLinkCellComponent } from './multiple-link-cell/multiple-link-cell.component';
import { InlineEditCellComponent } from './inline-edit-cell/inline-edit-cell.component';

export class NbSimpleRoleProvider extends NbRoleProvider {
  getRole() {
    // here you could provide any role based on any auth flow
    return observableOf('guest');
  }
}

export const NB_CORE_PROVIDERS = [
  ...NbAuthModule.forRoot({

    strategies: [
      NbDummyAuthStrategy.setup({
        name: 'email',
        delay: 3000,
      }),
    ],
  }).providers,

  NbSecurityModule.forRoot({
    accessControl: {
      guest: {
        view: '*',
      },
      user: {
        parent: 'guest',
        create: '*',
        edit: '*',
        remove: '*',
      },
    },
  }).providers,

  {
    provide: NbRoleProvider, useClass: NbSimpleRoleProvider,
  }
];

@NgModule({
  imports: [
    CommonModule,
    GenericTableModule,
    NbToggleModule,
    NbIconModule,
    NbEvaIconsModule,
    NbTooltipModule,
    NbSelectModule,
    NbCheckboxModule,
    NgxJsonViewerModule,
    NbProgressBarModule,
    NbCardModule,
    NbButtonModule,
    NbInputModule
  ],
  exports: [
    NbAuthModule,
  ],
  declarations: [
    AddChildCellComponent,
    ToggleButtonCellComponent,
    DownloadButtonComponent,
    SelectButtonComponent,
    IconButtonComponent,
    TooltipCellComponent,
    TextareaComponent,
    CheckboxCellComponent,
    BooleanCellComponent,
    JsonViewerComponent,
    ProgressBarCellComponent,
    MultipleLinkCellComponent,
    InlineEditCellComponent
  ],
  providers: [
    HttpService,
    LayoutService,
    AuthService,
    ExportService
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        ...NB_CORE_PROVIDERS,
      ],
    };
  }
}
